import { useEffect, useState } from "react";
import Footer from "../components/Footer/Footer";
import Nav from "../components/layout/Nav";
import MobileDrawer from "../components/MobileDrawer";

const Main = ({ children }) => {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const toggleDrawer = () => setIsOpen((prev) => !prev);
  return (
    <>
      <div className="dark bg-[#252427]">
        <Nav
          toggle={toggleDrawer}
          navLinks={navLinks}
        />
        <MobileDrawer
          toggle={toggleDrawer}
          open={isOpen}
          navLinks={navLinks}
        />
        {children}
      </div>
      <Footer />
    </>
  );
};

export default Main;
const navLinks = [
  { id: 1, text: "Prices", path: "/prices", internal: true },
  { id: 2, text: "White Paper", path: "/whitepaper", internal: true },
  { id: 3, text: "Get in touch", path: "mailto:lance@shinyheffers.io" },
];
